/* assets/diabetic-socks-v2-bundle.js
 * SL diabetic socks bundle add-on popup.
 *
 * The theme presents/collects add-ons and adds real variants to cart.
 * Shopify Admin automatic discounts remain the source of truth for special prices.
 */
(function () {
  function getCartAddUrl() {
    var base = window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : '/cart/add';
    return base.indexOf('.js') >= 0 ? base : base + '.js';
  }

  function getCartUrl() {
    return window.routes && window.routes.cartUrl ? window.routes.cartUrl : '/cart';
  }

  function getCheckoutUrl() {
    return (window.routes && window.routes.rootUrl ? window.routes.rootUrl.replace(/\/$/, '') : '') + '/checkout';
  }

  function parseJson(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent || '{}'); }
    catch (e) { console.error('[SocksBundle] Failed to parse bundle config', e); return null; }
  }

  function toNumber(value) {
    var number = parseInt(value, 10);
    return Number.isFinite(number) ? number : null;
  }

  function uniqueNumbers(values) {
    var seen = {};
    return values.filter(function (value) {
      var number = toNumber(value);
      if (!number || seen[number]) return false;
      seen[number] = true;
      return true;
    }).map(toNumber);
  }

  function callCartSuccess(action) {
    if (action === 'checkout') {
      window.location.assign(getCheckoutUrl());
      return;
    }

    try {
      if (window.theme && theme.Cart && theme.Cart.prototype && typeof theme.Cart.prototype._onProductAdded === 'function') {
        theme.Cart.prototype._onProductAdded();
        return;
      }
    } catch (e) {
      console.error('[SocksBundle] Cart drawer refresh failed', e);
    }

    // Avoid sending this landing flow to the cart page. If the drawer cannot
    // be opened for any reason, continue straight to checkout instead.
    window.location.assign(getCheckoutUrl());
  }

  function addFormToCart(form) {
    return fetch(getCartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json'
      },
      body: new URLSearchParams(new FormData(form)).toString()
    });
  }

  function addVariantsToCart(variantIds) {
    return fetch(getCartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: variantIds.map(function (id) { return { id: id, quantity: 1 }; })
      })
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) { return response.ok ? response.json() : { items: [] }; })
      .catch(function () { return { items: [] }; });
  }

  function SocksBundle(root) {
    this.root = root;
    this.section = root.closest('.dfs-offer-section') || root.closest('[id^="ProductSection-"]');
    this.form = root.closest('form') || (this.section && this.section.querySelector('[data-product-form]'));
    this.selector = this.section ? this.section.querySelector('[data-socks-pack-selector]') : null;
    this.variantInput = this.form ? this.form.querySelector('input[name="id"]') : null;
    this.config = parseJson(root.querySelector('[data-socks-bundle-config]')) || {};
    this.teaser = root.querySelector('[data-socks-bundle-teaser]');
    this.modal = root.querySelector('[data-socks-bundle-modal]');
    this.addButton = root.querySelector('[data-socks-bundle-add]');
    this.errorEl = root.querySelector('[data-socks-bundle-error]');
    this.formErrorEl = root.querySelector('[data-socks-bundle-form-error]');
    this.addonInputs = Array.prototype.slice.call(root.querySelectorAll('[data-socks-bundle-addon-input]'));
    this.skipButtons = Array.prototype.slice.call(root.querySelectorAll('[data-socks-bundle-skip]'));
    this.addToCartButton = this.section ? this.section.querySelector('[data-add-to-cart]') : null;
    this.addToCartText = this.addToCartButton ? this.addToCartButton.querySelector('[data-add-to-cart-text]') : null;
    this.originalAddText = this.addToCartText ? this.addToCartText.textContent : '';
    this.isSubmitting = false;
    this.isAddingAddons = false;
    this.currentPackKey = null;
    this.currentVariantId = this.variantInput ? toNumber(this.variantInput.value) : null;
    this.prevOverflow = '';
  }

  SocksBundle.prototype.init = function () {
    if (!this.config.enabled || !this.form || !this.variantInput || !this.modal) return;

    this.currentPackKey = this.getInitialPackKey();
    this.updateTeaser();
    this.bindEvents();
    this.syncAddonStates();
  };

  SocksBundle.prototype.getInitialPackKey = function () {
    if (!this.selector) return null;
    var active = this.selector.querySelector('[data-pack-card].is-active');
    if (active) return active.getAttribute('data-pack-key');
    return this.selector.getAttribute('data-default-pack') || null;
  };

  SocksBundle.prototype.bindEvents = function () {
    var self = this;

    if (this.selector) {
      this.selector.addEventListener('variantChange', function (event) {
        var detail = event.detail || {};
        self.currentPackKey = detail.packKey || self.currentPackKey;
        self.currentVariantId = detail.variant && detail.variant.id ? toNumber(detail.variant.id) : toNumber(self.variantInput.value);
        self.updateTeaser();
      });
    }

    this.form.addEventListener('submit', function (event) { self.handleSubmit(event); }, true);

    this.addonInputs.forEach(function (input) {
      input.addEventListener('change', function () { self.syncAddonStates(); });
    });

    this.skipButtons.forEach(function (button) {
      button.addEventListener('click', function () { self.closeModal(); callCartSuccess(self.config.postAddAction); });
    });

    if (this.addButton) {
      this.addButton.addEventListener('click', function () { self.handleAddons(); });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && self.modal && self.modal.classList.contains('is-open')) {
        self.closeModal();
        callCartSuccess(self.config.postAddAction);
      }
    });
  };

  SocksBundle.prototype.isQualifying = function (packKey, variantId) {
    var packs = this.config.qualifyingPackKeys || [];
    var variants = (this.config.qualifyingVariantIds || []).map(toNumber);
    var key = packKey || this.currentPackKey;
    var id = toNumber(variantId || this.currentVariantId);
    return (key && packs.indexOf(key) >= 0) || (id && variants.indexOf(id) >= 0);
  };

  SocksBundle.prototype.updateTeaser = function () {
    if (!this.teaser) return;
    this.teaser.hidden = !this.isQualifying();
  };

  SocksBundle.prototype.setMainLoading = function (loading) {
    if (!this.addToCartButton) return;
    if (loading) {
      this.addToCartButton.disabled = true;
      this.addToCartButton.setAttribute('aria-disabled', 'true');
      if (this.addToCartText && this.config.labels && this.config.labels.adding) this.addToCartText.textContent = this.config.labels.adding;
      return;
    }
    this.addToCartButton.removeAttribute('disabled');
    this.addToCartButton.removeAttribute('aria-disabled');
    if (this.addToCartText) this.addToCartText.textContent = this.originalAddText;
  };

  SocksBundle.prototype.handleSubmit = function (event) {
    var self = this;
    if (!this.config.enabled) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (this.isSubmitting) return;
    this.isSubmitting = true;
    this.hideError();
    var submittedPackKey = this.currentPackKey;
    var submittedVariantId = toNumber(this.variantInput.value);
    this.currentVariantId = submittedVariantId;
    this.setMainLoading(true);

    addFormToCart(this.form)
      .then(function (response) {
        if (!response.ok) throw response;
        return response.json().catch(function () { return {}; });
      })
      .then(function () {
        if (!self.isQualifying(submittedPackKey, submittedVariantId)) {
          self.isSubmitting = false;
          self.setMainLoading(false);
          callCartSuccess(self.config.postAddAction);
          return false;
        }
        return self.openIfHasAvailableAddons().then(function (openedModal) {
          if (openedModal) {
            self.isSubmitting = false;
            self.setMainLoading(false);
          }
          return openedModal;
        });
      })
      .catch(function (error) {
        console.error('[SocksBundle] Socks add failed', error);
        self.isSubmitting = false;
        self.setMainLoading(false);
        self.showFormError();
      });
  };

  SocksBundle.prototype.openIfHasAvailableAddons = function () {
    var self = this;
    return fetchCart().then(function (cart) {
      var existing = {};
      (cart.items || []).forEach(function (item) { existing[toNumber(item.variant_id || item.id)] = true; });

      var hasOfferable = false;
      self.addonInputs.forEach(function (input) {
        var variantId = toNumber(input.value);
        var wrapper = input.closest('[data-socks-bundle-addon]');
        var alreadyInCart = !!existing[variantId];
        input.disabled = input.disabled || alreadyInCart;
        if (wrapper) {
          wrapper.classList.toggle('is-disabled', input.disabled);
          wrapper.classList.toggle('is-in-cart', alreadyInCart);
        }
        if (!input.disabled) hasOfferable = true;
      });

      self.syncAddonStates();
      if (!hasOfferable) {
        callCartSuccess(self.config.postAddAction);
        return false;
      }
      self.openModal();
      return true;
    });
  };

  SocksBundle.prototype.getSelectedAddonIds = function () {
    return uniqueNumbers(this.addonInputs
      .filter(function (input) { return input.checked && !input.disabled; })
      .map(function (input) { return input.value; }));
  };

  SocksBundle.prototype.syncAddonStates = function () {
    this.addonInputs.forEach(function (input) {
      var wrapper = input.closest('[data-socks-bundle-addon]');
      if (wrapper) wrapper.classList.toggle('is-selected', input.checked && !input.disabled);
    });
    if (this.addButton) this.addButton.disabled = this.getSelectedAddonIds().length === 0 || this.isAddingAddons;
  };

  SocksBundle.prototype.openModal = function () {
    if (!this.modal) return;
    this.prevOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    this.hideError();
    this.modal.classList.add('is-open');
    this.modal.setAttribute('aria-hidden', 'false');
    this.syncAddonStates();
    var focusTarget = this.addButton || this.modal.querySelector('button');
    if (focusTarget) window.setTimeout(function () { focusTarget.focus(); }, 50);
  };

  SocksBundle.prototype.closeModal = function () {
    if (!this.modal) return;
    this.modal.classList.remove('is-open');
    this.modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = this.prevOverflow || '';
  };

  SocksBundle.prototype.handleAddons = function () {
    var self = this;
    var ids = this.getSelectedAddonIds();
    if (!ids.length || this.isAddingAddons) return;

    this.isAddingAddons = true;
    this.hideError();
    this.syncAddonStates();

    addVariantsToCart(ids)
      .then(function (response) {
        if (!response.ok) throw response;
        return response.json().catch(function () { return {}; });
      })
      .then(function () {
        self.isAddingAddons = false;
        self.closeModal();
        callCartSuccess(self.config.postAddAction);
      })
      .catch(function (error) {
        console.error('[SocksBundle] Add-on add failed', error);
        self.isAddingAddons = false;
        self.showModalError();
        self.syncAddonStates();
      });
  };

  SocksBundle.prototype.showFormError = function () {
    if (!this.formErrorEl) return;
    this.formErrorEl.hidden = false;
    if (this.config.labels && this.config.labels.error) this.formErrorEl.textContent = this.config.labels.error;
  };

  SocksBundle.prototype.showModalError = function () {
    if (!this.errorEl) return;
    this.errorEl.hidden = false;
    if (this.config.labels && this.config.labels.error) this.errorEl.textContent = this.config.labels.error;
  };

  SocksBundle.prototype.hideError = function () {
    if (this.errorEl) this.errorEl.hidden = true;
    if (this.formErrorEl) this.formErrorEl.hidden = true;
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-socks-bundle-root]').forEach(function (root) {
      if (root.__socksBundleInitialized) return;
      root.__socksBundleInitialized = true;
      new SocksBundle(root).init();
    });
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target || document); });
})();
